// import {checkTel} from "./tools";

export default {
    // 检查乘客信息
    // 拼音姓名，生日，性别必填，国家地区是中国的话，中文姓名必填
    checkGuestConfirm (guest) {
        if (guest.nationality == "CN") {
            if (!guest.firstName || guest.firstName.length == 0
                || !guest.lastName || guest.lastName.length == 0
                || !guest.birthDate || guest.birthDate.length == 0
                || !guest.gender || guest.gender.length == 0
                || !guest.pyLastName || guest.pyLastName.length == 0
                || !guest.pyFirstName || guest.pyFirstName.length == 0) {
                // || !guest.telephone || guest.telephone.length == 0) {
                return false;
            }
        } else {

            if ( !guest.birthDate || guest.birthDate.length == 0
                || !guest.gender || guest.gender.length == 0
                || !guest.pyLastName || guest.pyLastName.length == 0
                || !guest.pyFirstName || guest.pyFirstName.length == 0) {
                // || !guest.telephone || guest.telephone.length == 0) {
               return false
            }
        }
        return true
    },
    getStateroomGuestNumber (guestCount) {
        switch (guestCount) {
            case 1: return "单人房"
            case 2: return "双人房"
            case 3: return "三人房"
            case 4: return "四人房"
            default: return ""
        }
    },
    agencyId: "333545",
    pppAgencyId: "357932"
}
